export const SET_LOADER = 'SET_LOADER';

const initialState = {
  loader: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADER: {
      const { loader } = action;
      return {
        ...state,
        loader,
      };
    }
    default:
      return state;
  }
};

export const setLoader = loader => ({
  type: SET_LOADER,
  loader,
});

